import React from 'react'
import HelpTogal from '../TogelButton/HelpTogal'
import StarRating from '../Rating/StarRating'; 

function ViewFeedback({ feedback, closeModal, onSuccess }) {
  function formatDateTime(isoString) {
    const date = new Date(isoString);
    return date.toLocaleDateString();
  }
  return (
    <div className="modal fade viewbox edit-box show d-block" id="helpViewModal" tabIndex={-1} aria-labelledby="helpViewModal" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="helpViewModal">Details</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body px-5">
            <div className="d-box mt-3 pt-1">
              <ul className="d-flex list-unstyled justify-content-between">
                <li><span>User Name : </span>{`${feedback?.user?.firstName || "N/A"} ${feedback?.user?.lastName || ""}`.trim() || "N/A"}</li>
                <li><span>Mobile No: </span>{feedback?.user?.mobileNo}</li>
                <li><span>Brief: </span>{feedback?.comment}</li>
                <li><span>Service Name: </span>{feedback?.service?.title}</li>
                <li><span>Service Description: </span>{feedback?.service?.description}</li>
                <li><span>Service Price: </span>{feedback?.service?.offerPrice}</li>
                <li><span>Date: </span>{formatDateTime(feedback?.createdAt)}</li>
                <li><span>Rating </span>  <StarRating rating={feedback?.rating} /></li>
                <li><span>Image </span><br /> <img src={feedback?.user?.image ? `${process.env.REACT_APP_URL}${feedback.user.image}` : 'img/profile-img.png'}
                  alt="" style={{ height: '70px', width: '70px', objectFit: 'contain' }} /></li>

              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewFeedback